import { mapGetters, mapState } from 'vuex'

export default
{
	computed:
	{
		...mapState
		({
			reference: state => state.references.reference,
		}),

		...mapGetters
		([
			'hasReference'
		]),
	},
}